import React, { useState, useEffect } from "react";
import { Col, Label, Row, Input, Table } from "reactstrap";
import moment from "moment";
import logo from "../../../assets/images/logo-hoz_black.png";
import PriceUtils from "../../../helpers/PriceUtils";
import CalcUtils from "../../../helpers/CalcUltils";
import { reduce } from "lodash";
const Print = (props: any) => {
  const {
    data,
    componentRef,
    branch,
    payment_method_name,
    customerPrint,
    service_package_print
  } = props;
  
  const getFullAddressHeader = () => {
    const address = [
      branch?.[0]?.street,
      branch?.[0]?.wards_code?.name,
      branch?.[0]?.district_code?.name,
      branch?.[0]?.provinces_code?.name,
    ];
    return address?.filter((e: any) => e != null)?.join(", ");
  };
  const getFullAddress = () => {
    const address: any[] = [
      customerPrint?.street,
      customerPrint?.wards_code?.name,
      customerPrint?.district_code?.name,
      customerPrint?.provinces_code?.name,
    ];
    if (address.length > 0) {
      return address?.filter((e: any) => e != null)?.join(", ");
    } else {
      return "---";
    }
  };
  const date = () => {
    const year = moment().format("YYYY");
    const month = moment().format("MM");
    const day = moment().format("DD");
    return `Ngày ${day} tháng ${month} năm ${year}`;
  };

  const total = reduce(
    data,
    (prev: any, item: any) => {
      if (item?.service_id?.price) {
        prev += ((item?.service_id?.price * item?.service_quantity) - (item?.service_discount * item?.service_quantity));
      }
      return prev;
    },
    0
  );

  const PrintContent = () => {
    return (
      <div>
        <div
        className="header__print"
        style={{ marginTop: 30, borderBottom: "1px dashed #000000" }}
      >
        <div className="header__logo">
          <img src={logo} alt="" height="100" />
        </div>
        <div className="header__content">
          <div className="item">
            <Label className="value-text title" style={{ fontSize: "18px" }}>
              Phòng khám dinh dưỡng nhi Dr.Nutri - {branch?.[0]?.name}
            </Label>
          </div>
          <div className="item">
            <Label>Địa chỉ:</Label>
            <div className="value-text">{getFullAddressHeader()}</div>
          </div>
          <div className="item d-flex">
            <div className="d-flex">
              <Label>Điện thoại:</Label>
              <div className="value-text">
                {branch?.[0]?.hotline ? branch?.[0]?.hotline : ""}
              </div>
            </div>
            <div className="d-flex" style={{ marginLeft: 230 }}>
              <Label style={{width: 80}}>Email:</Label>
              <div className="value-text">
                {branch?.[0]?.email ? branch?.[0]?.email : ""}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="content__print">
        <div
          style={{
            paddingBottom: 15,
            marginBottom: 15,
          }}
        >
          <div
            style={{
              textAlign: "center",
              fontSize: "36px",
              fontWeight: "600",
              color: "#000000",
              marginTop: "20px",
              marginBottom: "15px",
            }}
          >
            PHIẾU THU DỊCH VỤ
          </div>
          <div style={{ textAlign: "center" }}>
            <p style={{ color: "#000000"}}>{date()}</p>
          </div>
          <div className="p-5 info-box">
            <div className="item">
              <Row>
                <Col md={6} xs={12}>
                  <div className="item-sub">
                    <Label>Khách hàng:</Label>
                    <div className="value-text">
                      {customerPrint?.name
                        ? customerPrint?.name
                        : ""}
                    </div>
                  </div>
                </Col>
                <Col md={6} xs={12}>
                  <div className="item-sub">
                    <Label>Mã khách hàng:</Label>
                    <div className="value-text">
                      {customerPrint?.code
                        ? customerPrint?.code
                        : ""}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="item">
              <Row>
                <Col md={6} xs={12}>
                  <div className="item-sub">
                    <Label>Tuổi:</Label>
                    <div className="value-text">
                      {CalcUtils.calculateAge(customerPrint?.birthday)}
                    </div>
                  </div>
                </Col>
                <Col md={6} xs={12}>
                  <div className="item-sub">
                    <Label>Số điện thoại:</Label>
                    <div className="value-text">
                      {customerPrint?.phone
                        ? customerPrint?.phone
                        : "---"}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="item">
              {customerPrint?.customer_guardians?.length > 0 && (
                <Row>
                  <Col md={6} xs={12}>
                    <div className="item-sub">
                      <Label>Người bảo hộ:</Label>
                      <div className="value-text">
                        {customerPrint?.customer_guardians?.[0]?.name}
                      </div>
                    </div>
                  </Col>
                  <Col md={6} xs={12}>
                    <div className="item-sub">
                      <Label>CMT/CCCD:</Label>
                      <div className="value-text">
                        {customerPrint?.customer_guardians?.[0]?.cccd}
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
            <div className="item">
              <Row>
                <Col md={12} xs={12}>
                  <div className="item-sub">
                    <Label>Địa chỉ:</Label>
                    <div className="value-text">{getFullAddress()}</div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="item">
              <Row>
                <Col md={6} xs={12}>
                  <div className="item-sub">
                    <Label>Hình thức thanh toán:</Label>
                    <div className="value-text">
                      {payment_method_name ? payment_method_name : "---"}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <Table responsive style={{ marginTop: 20 }}>
              <thead style={{ backgroundColor: "#F4F6F8" }}>
                <tr style={{ fontWeight: "bold", fontSize: "25px" }}>
                  <td
                    style={{
                      padding: 12,
                      fontSize: 21,
                      fontWeight: "bold",
                      color: "#000000",
                    }}
                  >
                    STT
                  </td>
                  <td
                    style={{
                      padding: 12,
                      fontSize: 21,
                      fontWeight: "bold",
                      color: "#000000",
                      textAlign: "start",
                      maxWidth: 300,
                    }}
                  >
                    Nội dung
                  </td>
                  <td
                    style={{
                      padding: 12,
                      fontSize: 21,
                      fontWeight: "bold",
                      color: "#000000",
                      // minWidth: 100,
                    }}
                  >
                    ĐVT
                  </td>
                  <td
                    style={{
                      padding: 12,
                      fontSize: 21,
                      fontWeight: "bold",
                      // minWidth: 100,
                      color: "#000000",
                    }}
                  >
                    SL
                  </td>
                  <td
                    style={{
                      padding: 12,
                      fontSize: 21,
                      fontWeight: "bold",
                      color: "#000000",
                      // minWidth: 100,
                      textAlign:"end"
                    }}
                  >
                    Đơn giá
                  </td>
                  <td
                    style={{
                      padding: 12,
                      fontSize: 21,
                      fontWeight: "bold",
                      color: "#000000",
                      // minWidth: 100,
                      textAlign:"end"
                    }}
                  >
                    Chiết khấu
                  </td>
                  <td
                    style={{
                      padding: 12,
                      fontSize: 21,
                      fontWeight: "bold",
                      color: "#000000",
                      // minWidth: 100,
                      textAlign:"end"
                    }}
                  >
                    Thành tiền
                  </td>
                </tr>
              </thead>
              <tbody>
                {data?.map((item: any, index: number) => {
                  return (
                    <tr>
                      <td
                        style={{
                          padding: 12,
                          color: "#000000",
                          textAlign: "center",
                          fontSize: 20,
                          borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000"
                        }}
                      >
                        {index + 1}
                      </td>
                      <td
                        style={{
                          padding: 12,
                          color: "#000000",
                          textAlign: "start",
                          fontSize: 20,
                          maxWidth: 300,
                          borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000"
                        }}
                      >
                        {item?.service_id?.name}
                      </td>
                      <td
                        style={{
                          padding: 12,
                          color: "#000000",
                          textAlign: "center",
                          fontSize: 20,
                          // minWidth: 100,
                          borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000"
                        }}
                      >
                        Lần
                      </td>
                      <td
                        style={{
                          padding: 12,
                          color: "#000000",
                          textAlign: "center",
                          fontSize: 20,
                          // minWidth: 100,
                          borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000"
                        }}
                      >
                        {item?.service_quantity}
                      </td>
                      <td
                        style={{
                          padding: 12,
                          color: "#000000",
                          textAlign: "end",
                          fontSize: 20,
                          // minWidth: 100,
                          borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000"
                        }}
                      >
                        {PriceUtils.format(item?.service_id?.price || "--", " đ")}
                      </td>
                      <td
                        style={{
                          padding: 12,
                          color: "#000000",
                          textAlign: "end",
                          fontSize: 20,
                          // minWidth: 100,
                          borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000"
                        }}
                      >
                        {PriceUtils.format(item?.service_discount || '--', ' đ')}
                      </td>
                      <td
                        style={{
                          padding: 12,
                          color: "#000000",
                          textAlign: "end",
                          fontSize: 20,
                          // minWidth: 100,
                          borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000"
                        }}
                      >
                        {PriceUtils.format(total || "--", " đ")}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <div style={{ fontSize: 20 }}>
              *Chiết khấu được tính trên đơn giá của mỗi dịch vụ
            </div>
            <tr className="no-border">
                <td
                  style={{
                    padding: 15,
                    color: "#000000",
                    fontSize: 20,
                    width: 350,
                  }}
                >
                  Tổng tiền
                </td>
                <td
                  style={{
                    padding: 15,
                    color: "#000000",
                    textAlign: "end",
                    width: 1100,
                  }}
                >
                  <span style={{ fontSize: 20 }}>
                    {PriceUtils.format(total, " đ")}
                  </span>
                </td>
              </tr>
              <tr className="no-border">
                <td
                  style={{
                    padding: 15,
                    color: "#000000",
                    fontSize: 20,
                    width: 400,
                  }}
                >
                  Chiết khấu gói thẻ dịch vụ <br />
                  {service_package_print ? `(${service_package_print?.name})` : null}
                </td>
                <td
                  style={{
                    padding: 15,
                    color: "#000000",
                    textAlign: "end",
                    width: 960,
                  }}
                >
                  <span style={{ fontSize: 20 }}>
                    {PriceUtils.format((data?.[0]?.partner == null ? total * service_package_print?.discount_service_examination / 100 : total * service_package_print?.discount_service_partner_examination / 100) || 0, " đ")}
                  </span>
                </td>
              </tr>
            <tr className="no-border">
              <td
                style={{
                  padding: 15,
                  color: "#000000",
                  fontWeight: "bold",
                  fontSize: 20,
                  width: 350,
                }}
              >
                Tổng tiền thanh toán
              </td>
              <td
                style={{
                  padding: 15,
                  color: "#000000",
                  textAlign: "end",
                  width: 1100,
                }}
              >
                <span style={{ fontSize: 20 }}>
                  {PriceUtils.format(total - ((data?.[0]?.partner == null ? total * service_package_print?.discount_service_examination / 100 : total * service_package_print?.discount_service_partner_examination / 100) || 0), " đ")}
                </span>
              </td>
            </tr>
            <tr className="no-border">
              <td
                style={{
                  padding: 15,
                  color: "#000000",
                  fontSize: 20,
                  borderTop: "none",
                  paddingTop: 0,
                  width: 350,
                }}
              >
                Số tiền viết bằng chữ
              </td>
              <td
                style={{
                  padding: 15,
                  color: "#000000",
                  borderTop: "none",
                  paddingTop: 0,
                  textAlign: "end",
                  width: 1100,
                  fontSize: 20,
                  fontStyle: "italic",
                  textTransform: "uppercase"
                }}
              >
                {PriceUtils.readMoney((total - ((data?.[0]?.partner == null ? total *service_package_print?.discount_service_examination / 100 : total *service_package_print?.discount_service_partner_examination / 100) || 0)).toString())}
              </td>
            </tr>
          </div>
        </div>
      </div>
      <div className="p-5" style={{ marginTop: 25 }}>
        <Row>
          <Col md={6}>
            <div className="text-center">
              <div
                className="label font-weight-bold pb-5"
                style={{ fontSize: 26 }}
              >
                Khách hàng
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className="text-center">
              <div
                className="label font-weight-bold pb-5"
                style={{ fontSize: 26 }}
              >
                Thu ngân
              </div>
              <div className="doctor-name mt-5 font-weight-bold">
                {/* {doctorPrint?.name || "---"} */}
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div
        style={{
          marginTop: 168,
          marginLeft: 48,
          marginRight: 48,
          marginBottom: 15,
        }}
      >
        <p className="text-center" style={{ color: "#000000", fontSize: 17 }}>
          Khách hàng vui lòng xuất trình phiếu này trong trường hợp muốn huỷ
          dịch vụ. Phòng khám khônog giải quyết các trường hợp nếu thiếu các
          giấy tờ trên. Tất cả các dịch vụ đã được bác sĩ tư vấn và thoả thuận
          với khách hàng. Khách hàng kiểm tra lại kỹ bảng kê trước khi thanh
          toán.
        </p>
      </div>
      <div
        style={{ fontStyle: "italic", color: "#000000", textAlign: "center" }}
      >
        <p className="mt-2">
          Xin cảm ơn Quý Khách đã lựa chọn dịch vụ y tế của chúng tôi!
        </p>
      </div>
      </div>
    )
  }

  return (
    <div
      className="print-content pre-print"
      style={{ overflow: "hidden" }}
      ref={componentRef}
    >
      <PrintContent/>
      <div className="page-break"></div>
      <PrintContent/>
    </div>
  );
};

export default Print;
